/* eslint-disable @next/next/no-sync-scripts */
import React from 'react';
import Head from 'next/head';
import { organization } from '@spotify-internal/structured-data-snippets';
import type { TextDirection } from '../../../shared-server/api/country-attributes/country-attributes';

const HeadContent = ({
  fields,
  direction,
  market,
  locale,
}: {
  fields: {
    title: string;
    description: string;
    image: string;
    video?: string;
  };
  direction: TextDirection;
  market: string;
  locale: string;
}) => {
  const title = `${direction === 'rtl' ? '\u200F' : ''}${
    fields.title
  } - Spotify (${market.split('-')[0].toUpperCase()})`;

  const sdOrganization = JSON.stringify(organization());

  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />

      <meta name="description" content={fields.description} />
      <meta property="og:description" content={fields.description} />

      <meta property="og:image:url" content={fields.image} />
      <meta property="og:image:secure_url" content={fields.image} />
      <meta property="twitter:image" content={fields.image} />

      <link rel="preconnect" href="https://wwwmarketing.scdn.co" />
      <link rel="preconnect" href="https://encore.scdn.co" />
      <link rel="preconnect" href="https://i.scdn.co" />

      <link rel="preconnect" href="https://www.google-analytics.com" />
      <link rel="preconnect" href="https://www.googletagmanager.com" />

      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, viewport-fit=cover"
      />
      <meta
        name="keywords"
        content="Spotify, music, online, listen, streaming, play, digital, album, artist, playlist"
      />

      <meta property="fb:app_id" content="174829003346" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Spotify" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@spotify" />

      <meta name="format-detection" content="telephone=no" />

      <meta name="theme-color" content="#000000" />

      <link
        rel="icon"
        type="image/png"
        href="https://wwwmarketing.scdn.co/img/favicon-16x16.png"
        sizes="16x16"
      />
      <link
        rel="icon"
        type="image/png"
        href="https://wwwmarketing.scdn.co/img/favicon-32x32.png"
        sizes="32x32"
      />
      <link
        rel="icon"
        type="image/png"
        href="https://wwwmarketing.scdn.co/img/favicon-96x96.png"
        sizes="96x96"
      />

      <link
        rel="apple-touch-icon"
        href="https://wwwmarketing.scdn.co/img/apple-touch-icon-120x120.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="https://wwwmarketing.scdn.co/img/apple-touch-icon-180x180.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href="https://wwwmarketing.scdn.co/img/apple-touch-icon-152x152.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="167x167"
        href="https://wwwmarketing.scdn.co/img/apple-touch-icon-167x167.png"
      />

      {!!fields?.video && <meta property="og:video" content={fields.video} />}

      <meta property="og:locale" content={locale} />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: sdOrganization }}
      />

      <script src="//cdn-spotify-experiments.conductrics.com/ac-eghtDoUasR/v3/agent-api/js/f-KWmMkxDncP/dt-7scsKMXYBS1WCjk1yGfrZdGi7sW6KP?apikey=api-OsskLsMgRBgUGDCuLtiW" />
    </Head>
  );
};

export default HeadContent;
